import { render, staticRenderFns } from "./confirm-communication-email.vue?vue&type=template&id=5dc89ca5&scoped=true&"
import script from "./confirm-communication-email.vue?vue&type=script&lang=js&"
export * from "./confirm-communication-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-communication-email.vue?vue&type=style&index=0&id=5dc89ca5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc89ca5",
  null
  
)

export default component.exports